import { get, post } from '../axios'

export function abtest_new_save_post(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest-new/save`, map)
}

export function abtest_new_list_post(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest-new/list`, map)
}

export function abtest_new_query_get(map) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest-new/query`, map)
}

export function abtest_new_queryLog_get(map) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest-new/queryLog`, map)
}

export function abtest_new_remove_get(map) {
  return get(`${process.env.VUE_APP_ABTEST}/abtest-new/remove`, map)
}

export function abtest_new_add_device_post(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest-new/add-device`, map)
}

export function abtest_new_modifystatus_post(map) {
  return post(`${process.env.VUE_APP_ABTEST}/abtest-new/modifystatus`, map)
}
